module.exports = __webpack_public_path__ + "static/media/mailnews_9.3c0fbd3f.ico";